import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";

import { ClientContext } from "../App";
import ButtonDropdownMenu from "../components/ButtonDropdownMenu";
import ButtonPrimary from "../components/ButtonPrimary";
import IgnitionSessionsTable from "../components/IgnitionSessionsTable";
import FilefeedImporterTrigger from "../components/filefeed/FilefeedImporterTrigger";
import OpenInNewTab from "../icons/OpenInNewTab";
import {
  getClientIgnitionConfigTemplates,
  openIgnitionSession,
} from "../lib/automatic";

const IgnitionSessions = () => {
  const { selectedClient } = useContext(ClientContext);

  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    if (!selectedClient) return;
    setTemplates([]);
    getClientIgnitionConfigTemplates(selectedClient).then(
      ([ignitionTemplates, ignitionTemplatesError]) => {
        if (ignitionTemplatesError) {
          toast.error(
            ignitionTemplatesError.message ||
              "Failed to load ignition templates."
          );
          return;
        }
        if (ignitionTemplates?.templates) {
          setTemplates(ignitionTemplates.templates);
        }
      }
    );
  }, [selectedClient]);

  const handleLaunchIgnition = async (templateId) => {
    const [ignitionSession, ignitionSessionError] = await openIgnitionSession(
      selectedClient,
      templateId
    );

    if (ignitionSessionError) {
      toast.error(
        ignitionSessionError.message || "Failed to open Ignition session."
      );
      return;
    }
    if (ignitionSession?.ignitionUri) {
      window.open(ignitionSession.ignitionUri, "_blank");
    }
  };

  const templateItems = [
    { label: "Default", onClick: () => handleLaunchIgnition(null) },
    ...templates.map((t) => ({
      label: t.displayName,
      onClick: () => handleLaunchIgnition(t.id),
    })),
  ];

  return (
    <div className="flex flex-col flex-1 h-full px-12 gap-y-8">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Ignition Sessions</h1>
        <div className="flex gap-x-2">
          {templates.length > 0 ? (
            <ButtonDropdownMenu
              label="Complete Ignition on behalf of user"
              leftIcon={OpenInNewTab}
              items={templateItems}
            />
          ) : (
            <ButtonPrimary
              text="Complete Ignition on behalf of user"
              icon={OpenInNewTab}
              onClick={() => handleLaunchIgnition(null)}
            />
          )}
          <FilefeedImporterTrigger />
        </div>
      </div>
      <IgnitionSessionsTable />
    </div>
  );
};

export default IgnitionSessions;
